// removed by extract-text-webpack-plugin
module.exports = {"languages":"Players__languages___20dne","wrapper":"Players__wrapper___TjaQR","players":"Players__players___3AAri","player":"Players__player___31kaz","icon":"Players__icon___3Fygc","active":"Players__active___3yN9_","remove":"Players__remove___3wgsC","addPlayer":"Players__addPlayer___tqVlo","input":"Players__input___3dQ5c","submit":"Players__submit___1OGvu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Players/Players.css
// module id = 944
// module chunks = 0